import React, { useEffect } from "react";
import { StyleSheet } from "react-native";
import { genderList } from "src/constant";
import { FormControlLabel } from "src/components";
import { colors } from "src/assets";
import { EventRegister } from "react-native-event-listeners";
import { navigationRef } from "src/hooks/navigation";
import { useController } from "react-hook-form";
import LocalText from "src/local";

export type AboutProfileControlProps = {
  control: any;
  error?: string;
};

export const AboutProfileControl: React.FC<AboutProfileControlProps> = ({
  control,
  error,
}) => {
  const { field } = useController({
    control,
    defaultValue: "",
    name: "aboutProfile",
  });
  const eventName = "MyPageAboutProfileEvent";
  useEffect(() => {
    const listener = EventRegister.addEventListener(eventName, (v: string) => {
      field.onChange(v.trim());
    });
    return () => {
      EventRegister.removeEventListener(listener as string);
    };
  }, [field]);
  return (
    <FormControlLabel
      text={
        field.value && field.value.length > 0
          ? field.value
          : LocalText.screens.myProfile.aboutProfileControl.description
      }
      textStyle={
        field.value && field.value.length > 0
          ? styles.text
          : styles.placeholderText
      }
      rightIcon={"chevron"}
      onPress={() => {
        navigationRef.current?.navigate("CustomTextEdit", {
          eventName: eventName,
          title: LocalText.screens.myProfile.aboutProfileControl.title,
          placeholder:
            LocalText.screens.myProfile.aboutProfileControl.placeholder,
          text: field.value,
          isMultiline: true,
        });
      }}
    />
  );
};

const styles = StyleSheet.create({
  placeholderText: {
    color: "#BABABA",
  },
  text: {
    color: colors.chokuBlack,
  },
});
